import { render, staticRenderFns } from "./Corporate.vue?vue&type=template&id=33edeb8c"
import script from "./Corporate.vue?vue&type=script&lang=js"
export * from "./Corporate.vue?vue&type=script&lang=js"
import style0 from "./Corporate.vue?vue&type=style&index=0&id=33edeb8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports